module.exports = __webpack_public_path__ + "static/media/Banner_Mobile2x.4f9d3fa9.jpg";